import apiClient from "../components/apiClient";
import MaterialUsage from "../models/MaterialUsage";

export class MaterialUsageService {
    static addMaterialUsage(materialUsage: MaterialUsage) : Promise<MaterialUsage> {
        return apiClient.post<MaterialUsage>(`/MaterialUsage/AddMaterialUsage`, materialUsage).then(res => res.data);
    }

    static getMaterialUsages() : Promise<MaterialUsage[]> {
        return apiClient.get<MaterialUsage[]>(`/MaterialUsage/GetMaterialUsages`).then(res => res.data);
    }

    static getMaterialUsage(usageCode: number) : Promise<MaterialUsage> {
        return apiClient.get<MaterialUsage>(`/MaterialUsage/GetMaterialUsage/${usageCode}`).then(res => res.data);
    }

    static updateMaterialUsage(materialUsage: MaterialUsage) : Promise<boolean> {
        return apiClient.put<boolean>(`/MaterialUsage/UpdateMaterialUsage`, materialUsage).then(res => res.data);
    }

    static deleteMaterialUsage(id: number) : Promise<boolean> {
        return apiClient.delete<boolean>(`/MaterialUsage/DeleteMaterialUsage/${id}`).then(res => res.data);
    }
}